
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          {/* Left Column - Logo & Social */}
          <div className="md:col-span-5">
            <div className="w-64 h-64 flex items-center justify-center mb-8">
              <img 
                src="https://static.readdy.ai/image/4abb71d54c7d60621cfc0b2fab4f7970/3b1e60a7c97fafd8931cbea82c7dfd99.png" 
                alt="Nightmare Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-gray-500 mb-6">Official site of Zane Morehouse</p>

            {/* Social Media Icons */}
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="w-12 h-12 flex items-center justify-center bg-[#141414] hover:bg-[#8B0000] text-gray-400 hover:text-white rounded transition-all duration-300 cursor-pointer border border-gray-800 hover:border-[#8B0000]"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-12 h-12 flex items-center justify-center bg-[#141414] hover:bg-[#8B0000] text-gray-400 hover:text-white rounded transition-all duration-300 cursor-pointer border border-gray-800 hover:border-[#8B0000]"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-12 h-12 flex items-center justify-center bg-[#141414] hover:bg-[#8B0000] text-gray-400 hover:text-white rounded transition-all duration-300 cursor-pointer border border-gray-800 hover:border-[#8B0000]"
              >
                <i className="ri-tiktok-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-12 h-12 flex items-center justify-center bg-[#141414] hover:bg-[#8B0000] text-gray-400 hover:text-white rounded transition-all duration-300 cursor-pointer border border-gray-800 hover:border-[#8B0000]"
              >
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Middle Column - Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-white text-lg font-bold mb-6 uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('bio')}
                  className="text-gray-500 hover:text-[#8B0000] transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('stats')}
                  className="text-gray-500 hover:text-[#8B0000] transition-colors cursor-pointer"
                >
                  Statistics
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('news')}
                  className="text-gray-500 hover:text-[#8B0000] transition-colors cursor-pointer"
                >
                  News
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('merchandise')}
                  className="text-gray-500 hover:text-[#8B0000] transition-colors cursor-pointer"
                >
                  Shop
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('tips')}
                  className="text-gray-500 hover:text-[#8B0000] transition-colors cursor-pointer"
                >
                  Tips & Tricks
                </button>
              </li>
            </ul>
          </div>

          {/* Right Column - Newsletter */}
          <div className="md:col-span-4">
            <h4 className="text-white text-lg font-bold mb-6 uppercase tracking-wider">
              Newsletter
            </h4>
            <p className="text-gray-500 mb-6">
              Get exclusive updates and merch drops
            </p>
            <div className="space-y-3">
              <input
                type="email"
                placeholder="Your email address"
                className="w-full bg-[#141414] text-white px-4 py-3 rounded border border-gray-800 focus:border-[#8B0000] focus:outline-none transition-colors"
              />
              <button className="w-full bg-[#8B0000] hover:bg-[#6B0000] text-white font-semibold py-3 rounded transition-all duration-300 whitespace-nowrap cursor-pointer">
                SUBSCRIBE
              </button>
            </div>
            <p className="text-gray-700 text-xs mt-4">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-600 text-sm text-center md:text-left">
              © 2025 Zane Morehouse. All Rights Reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-[#8B0000] text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
